module.exports = __webpack_public_path__ + "54cf98f5/img/boston-lights.a623432f.png";